import { DirectionsBike, FiberManualRecord } from '@mui/icons-material';
import { useContext, useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { CurrentPContext, MasterContext, MobiOrNotContext } from "../../ContextApi/context";
import utilsRests from "../../_Utils/utilsRests";
import { getRandomDelay } from './delayManager';

import { Swiper, SwiperSlide } from 'swiper/react';
// Import Swiper styles
import 'swiper/swiper-bundle.min.css';
import 'swiper/swiper.min.css';
import ConnUrls from "../../Connections/ConnectURL";
import MyDateTime from "../../DTechComp/MyDateTime";
import myFunctions from "../../myFunctions";
import { Autoplay } from 'swiper';
import useNotDelivering from '../../DTechComp/useNotDelivering';

const MainNowOpen = (props) => {
    const [master] = useContext(MasterContext);
    const notDeliveringTxt = useNotDelivering();

    const [currentPage, setCurrentPage] = useContext(CurrentPContext);
    const [mobiOrNot, setMobiOrNot] = useContext(MobiOrNotContext);

    const [currentP, setCurrentP] = useState(props.TheList);
    const [mainNowOpen, setMainNowOpen] = useState([]);


    useEffect(() => {
        getMRsts();

    }, [])


    const getMRsts = async () => {

        let allList = await utilsRests.getRestNowOpen({ maxItems: 150 });
        setMainNowOpen(allList);
        //אים אין מסעדות זמינות כרגע, מעדכן את דף הבית ומסתיר את החלק של זמינות עכשיו
        if (allList.length < 1) { props.noOpenRests(false); }
    }

    return (
        mainNowOpen.filter(item => item != null).length > 0 && props.header &&
        <>
            <div className={"spaceBLockesUp_Minus-10 spaceRightLong MbigFont bold SecondFont spaceBLockesDown_Minus-10"}>
                {props.header}
            </div>
            <div className={"FourMainLnksDiv spaceBLockesUp_Minus-10"}>
                <Swiper

                    reverseDirection={false}
                    spaceBetween={mobiOrNot ? 10 : 16}
                    slidesPerGroup={1}
                    slidesPerView={mobiOrNot ? 3 : 6}
                    loop={false}
                    initialSlide={0}
                    speed={3000}
                    // onSlideChange={() => console.log('slide change')}
                    freeMode={true}
                    loopFillGroupWithBlank={true}

                // onSwiper={(swiper) => console.log(swiper)}
                >
                    {
                        mainNowOpen.map((item, index) => {
                            if (item != null) {
                                let timing = (item.Delivery?.Time) ? item.Delivery.Time : (item.TakeAway?.Time) ? item.TakeAway.Time : 30;
                                let timingChannel = (item.Delivery?.Time) ? "Deliver" : "Take";
                                timing = myFunctions.checkForDeliverysDelay(master, timing, timingChannel);

                                let priceing = (item.Delivery?.Price) ? item.Delivery.Price : (item.TakeAway?.Price) ? item.TakeAway.Price : 20;
                                let chans = MyDateTime.resolveBusinessChannels(item, master);

                                // (!master.blockDeliverys ||
                                //     !master.blockPickUps) ?
                                //     item.Delivery?.Doing ||
                                //         item.TakeAway?.Doing ?
                                //         true : false
                                //     : false;

                                let notGettinOrders = myFunctions.notGettinOrders(master, item, chans);



                                return (
                                    <SwiperSlide key={index} className={mobiOrNot ? "favBtn" : "NotfavBtn"}>
                                        <Link to={`/restaurants/${item.pageUrlFix != null && item.pageUrlFix != "" ? item.pageUrlFix : item._id}`}>


                                            <div className={"imgWrap animate__animated pulseME"}>

                                                <div className={"imgDiv mainFavImgDiv"} style={{ backgroundImage: `url("${ConnUrls.media(item.buissMainImg)}")` }} >

                                                    {(notGettinOrders != "") ?
                                                        <div data-nosnippet className={"no-render imgWrapDivClose imgWrapDivCloseSmall"}><span>{notGettinOrders}</span></div> : ""}

                                                    {/* <div className={"imgDiv mainFavImgDiv"} style={{ backgroundImage: `url("${ConnUrls.media(item.buissMainImg)}")` }} >

                                            </div> */}
                                                    <div style={{ position: "relative", bottom: mobiOrNot ? "5px" : "10px" }}>
                                                        <div className={"botBlock"}>
                                                            <div className={"width_90"}>
                                                                <div className={`pgBigTxt dottedLine_2 regularFont bold`}>
                                                                    {item.buissName}
                                                                </div>
                                                                <div className={`pgSmallTxt grayText ${(mobiOrNot) ? "mediumst" : "regularFont"}`}>

                                                                    <span>{item.buissKitchType}</span>
                                                                </div>
                                                                {/* עסק שלא שולח לעיר שהלקוח בחר */}
                                                                {notDeliveringTxt(item) &&
                                                                    <div className={"pgSmallTxt"}><span className={"notDelivTag"}>{notDeliveringTxt(item)}</span></div>}


                                                            </div>


                                                        </div>
                                                    </div>
                                                </div>
                                            </div>


                                        </Link>
                                    </SwiperSlide>
                                )
                            }
                        })
                    }
                    {[...Array(mobiOrNot ? parseInt(mainNowOpen.length / 9) + 1 : parseInt(mainNowOpen.length / 18) + 1)].map((_, i) => (
                        <SwiperSlide key={mainNowOpen.length + i + 1} className={"NotfavBtn spacerfavBtn"}>
                            <Link to="">
                                <div className={"imgWrap animate__animated pulseME"}>
                                    <div className={"imgDiv mainFavImgDiv"} >
                                        <div style={{ position: "relative", bottom: mobiOrNot ? "5px" : "10px" }}>
                                            <div className={"botBlock"}>
                                                <div className={"width_90"}>
                                                    <div className={`pgSmallTxt grayText ${(mobiOrNot) ? "mediumst" : "regularFont"}`}>
                                                        <span>{""}</span>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </Link>
                        </SwiperSlide>
                    ))}

                </Swiper>
            </div >
        </>
    )
}

export default MainNowOpen;